export const store = {
  isSticky: true,
  hideNav() {
    this.isSticky = true;
  },
  showNav() {
    this.isSticky = false;
  },
};
